import logger from 'ws-scripts/modules/logger';
import { radiusChanged } from '../features/facetsSlice';

const LOG_PREFIX = '[ws-locations-facets][radiusMiddleware]';

/**
 * Middleware that synchronizes radius changes with the global LocationsData API.
 *
 * @param {Object} _store - Redux store
 * @returns {Function} Middleware function
 */
const radiusMiddleware = (_store) => (next) => (action) => {
	const result = next(action);

	if (radiusChanged.match(action)) {
		const radius = action.payload;

		try {
			const locationsData = window.DDC?.LocationsData;

			if (!locationsData) {
				logger.warn(
					`${LOG_PREFIX} window.DDC.LocationsData not available`
				);
				return result;
			}

			const postalCode = locationsData.getPostalCode();

			if (!postalCode || postalCode.trim() === '') {
				logger.warn(
					`${LOG_PREFIX} Cannot update search: postal code not available`
				);
				return result;
			}

			const excludeByRange = true;
			locationsData.setSearchParams(postalCode, radius, excludeByRange);
		} catch (error) {
			logger.error(
				`${LOG_PREFIX} Failed to update search parameters:`,
				error
			);
		}
	}

	return result;
};

export default radiusMiddleware;
